import '../components/entry/EntryPage.css';
import { Helmet } from 'react-helmet-async';

const EntryPage = () => {

    return (
        <div>
            <Helmet>
                <title>Room 49 - Entry</title>
                <meta name="description" content="Guidelines on how to use the Room 49 door entry keypad." />
                <link rel="canonical" href='https://thetypingrooms.co.uk/projector' />
            </Helmet>
            <div className="page">
                <div className='page-header'>
                    <h1>Door entry</h1>
                </div>
                <div className='page-content'>
                    <div className="contact-container">
                        <div className='entry-text-container'>
                            <h2>Keypad</h2>
                            <p>
                                The Unifi keypad looks a bit like a skinny iPhone—it's mounted on the wall to the left of the door. The screen will be blank at first, so wake it up by stepping towards it or tapping the screen. You'll see the Room 49 logo, with two options at the bottom.
                            </p>
                            <h2>PIN Entry</h2>
                            <p>
                                Tap PIN (bottom right). Enter the 8-digit code from your confirmation email. You'll hear a soft click and a “ding-dong” sound when the door unlocks—just push it open.
                            </p>
                            <h2>QR Entry</h2>
                            <p>
                                Tap QR (bottom left). Open your QR code (either from email or saved in Apple/Google Wallet). Hold a few centimetres from the screen so the camera can focus—a bright screen helps. You'll hear a soft click and a “ding-dong” once it's accepted, and the door can then be pushed open.
                            </p>
                            <h2>Door close</h2>
                            <p>
                                Please make sure the door closes properly behind you so it locks securely for the next person.
                            </p>

                        </div>
                        <div className='entry-image-container'>
                            <img src="/images/door-entry.png" alt="Door entry keypad" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EntryPage;
